export enum BookingType {
  CUSTOMER_BOOKING = 'CUSTOMER_BOOKING',
  PARTNER_BOOKING = 'PARTNER_BOOKING',
  MAINTENANCE_BOOKING = 'MAINTENANCE_BOOKING',
  TRANSFER_RETURN_BOOKING = 'TRANSFER_RETURN_BOOKING',
  TRANSFER_DELIVERY_BOOKING = 'TRANSFER_DELIVERY_BOOKING',
}
